const countries = [
  {
    alpha2: 'AF',
    alpha3: 'AFG',
    name: 'Afghanistan',
    numeric: '004',
    officialName: 'Islamic Republic of Afghanistan',
  },
  {
    alpha2: 'AL',
    alpha3: 'ALB',
    name: 'Albania',
    numeric: '008',
    officialName: 'Republic of Albania',
  },
  {
    alpha2: 'DZ',
    alpha3: 'DZA',
    name: 'Algeria',
    numeric: '012',
    officialName: "People's Democratic Republic of Algeria",
  },
  {
    alpha2: 'AS',
    alpha3: 'ASM',
    name: 'American Samoa',
    numeric: '016',
  },
  {
    alpha2: 'AD',
    alpha3: 'AND',
    name: 'Andorra',
    numeric: '020',
    officialName: 'Principality of Andorra',
  },
  {
    alpha2: 'AO',
    alpha3: 'AGO',
    name: 'Angola',
    numeric: '024',
    officialName: 'Republic of Angola',
  },
  {
    alpha2: 'AI',
    alpha3: 'AIA',
    name: 'Anguilla',
    numeric: '660',
  },
  {
    alpha2: 'AQ',
    alpha3: 'ATA',
    name: 'Antarctica',
    numeric: '010',
  },
  {
    alpha2: 'AG',
    alpha3: 'ATG',
    name: 'Antigua and Barbuda',
    numeric: '028',
  },
  {
    alpha2: 'AR',
    alpha3: 'ARG',
    name: 'Argentina',
    numeric: '032',
    officialName: 'Argentine Republic',
  },
  {
    alpha2: 'AM',
    alpha3: 'ARM',
    name: 'Armenia',
    numeric: '051',
    officialName: 'Republic of Armenia',
  },
  {
    alpha2: 'AW',
    alpha3: 'ABW',
    name: 'Aruba',
    numeric: '533',
  },
  {
    alpha2: 'AU',
    alpha3: 'AUS',
    name: 'Australia',
    numeric: '036',
  },
  {
    alpha2: 'AT',
    alpha3: 'AUT',
    name: 'Austria',
    numeric: '040',
    officialName: 'Republic of Austria',
  },
  {
    alpha2: 'AZ',
    alpha3: 'AZE',
    name: 'Azerbaijan',
    numeric: '031',
    officialName: 'Republic of Azerbaijan',
  },
  {
    alpha2: 'BS',
    alpha3: 'BHS',
    name: 'Bahamas',
    numeric: '044',
    officialName: 'Commonwealth of the Bahamas',
  },
  {
    alpha2: 'BH',
    alpha3: 'BHR',
    name: 'Bahrain',
    numeric: '048',
    officialName: 'Kingdom of Bahrain',
  },
  {
    alpha2: 'BD',
    alpha3: 'BGD',
    name: 'Bangladesh',
    numeric: '050',
    officialName: "People's Republic of Bangladesh",
  },
  {
    alpha2: 'BB',
    alpha3: 'BRB',
    name: 'Barbados',
    numeric: '052',
  },
  {
    alpha2: 'BY',
    alpha3: 'BLR',
    name: 'Belarus',
    numeric: '112',
    officialName: 'Republic of Belarus',
  },
  {
    alpha2: 'BE',
    alpha3: 'BEL',
    name: 'Belgium',
    numeric: '056',
    officialName: 'Kingdom of Belgium',
  },
  {
    alpha2: 'BZ',
    alpha3: 'BLZ',
    name: 'Belize',
    numeric: '084',
  },
  {
    alpha2: 'BJ',
    alpha3: 'BEN',
    name: 'Benin',
    numeric: '204',
    officialName: 'Republic of Benin',
  },
  {
    alpha2: 'BM',
    alpha3: 'BMU',
    name: 'Bermuda',
    numeric: '060',
  },
  {
    alpha2: 'BT',
    alpha3: 'BTN',
    name: 'Bhutan',
    numeric: '064',
    officialName: 'Kingdom of Bhutan',
  },
  {
    alpha2: 'BO',
    alpha3: 'BOL',
    common_name: 'Bolivia',
    name: 'Bolivia, Plurinational State of',
    numeric: '068',
    officialName: 'Plurinational State of Bolivia',
  },
  {
    alpha2: 'BQ',
    alpha3: 'BES',
    name: 'Bonaire, Sint Eustatius and Saba',
    numeric: '535',
    officialName: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    alpha2: 'BA',
    alpha3: 'BIH',
    name: 'Bosnia and Herzegovina',
    numeric: '070',
    officialName: 'Republic of Bosnia and Herzegovina',
  },
  {
    alpha2: 'BW',
    alpha3: 'BWA',
    name: 'Botswana',
    numeric: '072',
    officialName: 'Republic of Botswana',
  },
  {
    alpha2: 'BV',
    alpha3: 'BVT',
    name: 'Bouvet Island',
    numeric: '074',
  },
  {
    alpha2: 'BR',
    alpha3: 'BRA',
    name: 'Brazil',
    numeric: '076',
    officialName: 'Federative Republic of Brazil',
  },
  {
    alpha2: 'IO',
    alpha3: 'IOT',
    name: 'British Indian Ocean Territory',
    numeric: '086',
  },
  {
    alpha2: 'BN',
    alpha3: 'BRN',
    name: 'Brunei Darussalam',
    numeric: '096',
  },
  {
    alpha2: 'BG',
    alpha3: 'BGR',
    name: 'Bulgaria',
    numeric: '100',
    officialName: 'Republic of Bulgaria',
  },
  {
    alpha2: 'BF',
    alpha3: 'BFA',
    name: 'Burkina Faso',
    numeric: '854',
  },
  {
    alpha2: 'BI',
    alpha3: 'BDI',
    name: 'Burundi',
    numeric: '108',
    officialName: 'Republic of Burundi',
  },
  {
    alpha2: 'CV',
    alpha3: 'CPV',
    name: 'Cabo Verde',
    numeric: '132',
    officialName: 'Republic of Cabo Verde',
  },
  {
    alpha2: 'KH',
    alpha3: 'KHM',
    name: 'Cambodia',
    numeric: '116',
    officialName: 'Kingdom of Cambodia',
  },
  {
    alpha2: 'CM',
    alpha3: 'CMR',
    name: 'Cameroon',
    numeric: '120',
    officialName: 'Republic of Cameroon',
  },
  {
    alpha2: 'CA',
    alpha3: 'CAN',
    name: 'Canada',
    numeric: '124',
  },
  {
    alpha2: 'KY',
    alpha3: 'CYM',
    name: 'Cayman Islands',
    numeric: '136',
  },
  {
    alpha2: 'CF',
    alpha3: 'CAF',
    name: 'Central African Republic',
    numeric: '140',
  },
  {
    alpha2: 'TD',
    alpha3: 'TCD',
    name: 'Chad',
    numeric: '148',
    officialName: 'Republic of Chad',
  },
  {
    alpha2: 'CL',
    alpha3: 'CHL',
    name: 'Chile',
    numeric: '152',
    officialName: 'Republic of Chile',
  },
  {
    alpha2: 'CN',
    alpha3: 'CHN',
    name: 'China',
    numeric: '156',
    officialName: "People's Republic of China",
  },
  {
    alpha2: 'CX',
    alpha3: 'CXR',
    name: 'Christmas Island',
    numeric: '162',
  },
  {
    alpha2: 'CC',
    alpha3: 'CCK',
    name: 'Cocos (Keeling) Islands',
    numeric: '166',
  },
  {
    alpha2: 'CO',
    alpha3: 'COL',
    name: 'Colombia',
    numeric: '170',
    officialName: 'Republic of Colombia',
  },
  {
    alpha2: 'KM',
    alpha3: 'COM',
    name: 'Comoros',
    numeric: '174',
    officialName: 'Union of the Comoros',
  },
  {
    alpha2: 'CG',
    alpha3: 'COG',
    name: 'Congo',
    numeric: '178',
    officialName: 'Republic of the Congo',
  },
  {
    alpha2: 'CD',
    alpha3: 'COD',
    name: 'Congo, The Democratic Republic of the',
    numeric: '180',
  },
  {
    alpha2: 'CK',
    alpha3: 'COK',
    name: 'Cook Islands',
    numeric: '184',
  },
  {
    alpha2: 'CR',
    alpha3: 'CRI',
    name: 'Costa Rica',
    numeric: '188',
    officialName: 'Republic of Costa Rica',
  },
  {
    alpha2: 'HR',
    alpha3: 'HRV',
    name: 'Croatia',
    numeric: '191',
    officialName: 'Republic of Croatia',
  },
  {
    alpha2: 'CU',
    alpha3: 'CUB',
    name: 'Cuba',
    numeric: '192',
    officialName: 'Republic of Cuba',
  },
  {
    alpha2: 'CW',
    alpha3: 'CUW',
    name: 'Curaçao',
    numeric: '531',
    officialName: 'Curaçao',
  },
  {
    alpha2: 'CY',
    alpha3: 'CYP',
    name: 'Cyprus',
    numeric: '196',
    officialName: 'Republic of Cyprus',
  },
  {
    alpha2: 'CZ',
    alpha3: 'CZE',
    name: 'Czechia',
    numeric: '203',
    officialName: 'Czech Republic',
  },
  {
    alpha2: 'CI',
    alpha3: 'CIV',
    name: "Côte d'Ivoire",
    numeric: '384',
    officialName: "Republic of Côte d'Ivoire",
  },
  {
    alpha2: 'DK',
    alpha3: 'DNK',
    name: 'Denmark',
    numeric: '208',
    officialName: 'Kingdom of Denmark',
  },
  {
    alpha2: 'DJ',
    alpha3: 'DJI',
    name: 'Djibouti',
    numeric: '262',
    officialName: 'Republic of Djibouti',
  },
  {
    alpha2: 'DM',
    alpha3: 'DMA',
    name: 'Dominica',
    numeric: '212',
    officialName: 'Commonwealth of Dominica',
  },
  {
    alpha2: 'DO',
    alpha3: 'DOM',
    name: 'Dominican Republic',
    numeric: '214',
  },
  {
    alpha2: 'EC',
    alpha3: 'ECU',
    name: 'Ecuador',
    numeric: '218',
    officialName: 'Republic of Ecuador',
  },
  {
    alpha2: 'EG',
    alpha3: 'EGY',
    name: 'Egypt',
    numeric: '818',
    officialName: 'Arab Republic of Egypt',
  },
  {
    alpha2: 'SV',
    alpha3: 'SLV',
    name: 'El Salvador',
    numeric: '222',
    officialName: 'Republic of El Salvador',
  },
  {
    alpha2: 'GQ',
    alpha3: 'GNQ',
    name: 'Equatorial Guinea',
    numeric: '226',
    officialName: 'Republic of Equatorial Guinea',
  },
  {
    alpha2: 'ER',
    alpha3: 'ERI',
    name: 'Eritrea',
    numeric: '232',
    officialName: 'the State of Eritrea',
  },
  {
    alpha2: 'EE',
    alpha3: 'EST',
    name: 'Estonia',
    numeric: '233',
    officialName: 'Republic of Estonia',
  },
  {
    alpha2: 'SZ',
    alpha3: 'SWZ',
    name: 'Eswatini',
    numeric: '748',
    officialName: 'Kingdom of Eswatini',
  },
  {
    alpha2: 'ET',
    alpha3: 'ETH',
    name: 'Ethiopia',
    numeric: '231',
    officialName: 'Federal Democratic Republic of Ethiopia',
  },
  {
    alpha2: 'FK',
    alpha3: 'FLK',
    name: 'Falkland Islands (Malvinas)',
    numeric: '238',
  },
  {
    alpha2: 'FO',
    alpha3: 'FRO',
    name: 'Faroe Islands',
    numeric: '234',
  },
  {
    alpha2: 'FJ',
    alpha3: 'FJI',
    name: 'Fiji',
    numeric: '242',
    officialName: 'Republic of Fiji',
  },
  {
    alpha2: 'FI',
    alpha3: 'FIN',
    name: 'Finland',
    numeric: '246',
    officialName: 'Republic of Finland',
  },
  {
    alpha2: 'FR',
    alpha3: 'FRA',
    name: 'France',
    numeric: '250',
    officialName: 'French Republic',
  },
  {
    alpha2: 'GF',
    alpha3: 'GUF',
    name: 'French Guiana',
    numeric: '254',
  },
  {
    alpha2: 'PF',
    alpha3: 'PYF',
    name: 'French Polynesia',
    numeric: '258',
  },
  {
    alpha2: 'TF',
    alpha3: 'ATF',
    name: 'French Southern Territories',
    numeric: '260',
  },
  {
    alpha2: 'GA',
    alpha3: 'GAB',
    name: 'Gabon',
    numeric: '266',
    officialName: 'Gabonese Republic',
  },
  {
    alpha2: 'GM',
    alpha3: 'GMB',
    name: 'Gambia',
    numeric: '270',
    officialName: 'Republic of the Gambia',
  },
  {
    alpha2: 'GE',
    alpha3: 'GEO',
    name: 'Georgia',
    numeric: '268',
  },
  {
    alpha2: 'DE',
    alpha3: 'DEU',
    name: 'Germany',
    numeric: '276',
    officialName: 'Federal Republic of Germany',
  },
  {
    alpha2: 'GH',
    alpha3: 'GHA',
    name: 'Ghana',
    numeric: '288',
    officialName: 'Republic of Ghana',
  },
  {
    alpha2: 'GI',
    alpha3: 'GIB',
    name: 'Gibraltar',
    numeric: '292',
  },
  {
    alpha2: 'GR',
    alpha3: 'GRC',
    name: 'Greece',
    numeric: '300',
    officialName: 'Hellenic Republic',
  },
  {
    alpha2: 'GL',
    alpha3: 'GRL',
    name: 'Greenland',
    numeric: '304',
  },
  {
    alpha2: 'GD',
    alpha3: 'GRD',
    name: 'Grenada',
    numeric: '308',
  },
  {
    alpha2: 'GP',
    alpha3: 'GLP',
    name: 'Guadeloupe',
    numeric: '312',
  },
  {
    alpha2: 'GU',
    alpha3: 'GUM',
    name: 'Guam',
    numeric: '316',
  },
  {
    alpha2: 'GT',
    alpha3: 'GTM',
    name: 'Guatemala',
    numeric: '320',
    officialName: 'Republic of Guatemala',
  },
  {
    alpha2: 'GG',
    alpha3: 'GGY',
    name: 'Guernsey',
    numeric: '831',
  },
  {
    alpha2: 'GN',
    alpha3: 'GIN',
    name: 'Guinea',
    numeric: '324',
    officialName: 'Republic of Guinea',
  },
  {
    alpha2: 'GW',
    alpha3: 'GNB',
    name: 'Guinea-Bissau',
    numeric: '624',
    officialName: 'Republic of Guinea-Bissau',
  },
  {
    alpha2: 'GY',
    alpha3: 'GUY',
    name: 'Guyana',
    numeric: '328',
    officialName: 'Republic of Guyana',
  },
  {
    alpha2: 'HT',
    alpha3: 'HTI',
    name: 'Haiti',
    numeric: '332',
    officialName: 'Republic of Haiti',
  },
  {
    alpha2: 'HM',
    alpha3: 'HMD',
    name: 'Heard Island and McDonald Islands',
    numeric: '334',
  },
  {
    alpha2: 'VA',
    alpha3: 'VAT',
    name: 'Holy See (Vatican City State)',
    numeric: '336',
  },
  {
    alpha2: 'HN',
    alpha3: 'HND',
    name: 'Honduras',
    numeric: '340',
    officialName: 'Republic of Honduras',
  },
  {
    alpha2: 'HK',
    alpha3: 'HKG',
    name: 'Hong Kong',
    numeric: '344',
    officialName: 'Hong Kong Special Administrative Region of China',
  },
  {
    alpha2: 'HU',
    alpha3: 'HUN',
    name: 'Hungary',
    numeric: '348',
    officialName: 'Hungary',
  },
  {
    alpha2: 'IS',
    alpha3: 'ISL',
    name: 'Iceland',
    numeric: '352',
    officialName: 'Republic of Iceland',
  },
  {
    alpha2: 'IN',
    alpha3: 'IND',
    name: 'India',
    numeric: '356',
    officialName: 'Republic of India',
  },
  {
    alpha2: 'ID',
    alpha3: 'IDN',
    name: 'Indonesia',
    numeric: '360',
    officialName: 'Republic of Indonesia',
  },
  {
    alpha2: 'IR',
    alpha3: 'IRN',
    name: 'Iran, Islamic Republic of',
    numeric: '364',
    officialName: 'Islamic Republic of Iran',
  },
  {
    alpha2: 'IQ',
    alpha3: 'IRQ',
    name: 'Iraq',
    numeric: '368',
    officialName: 'Republic of Iraq',
  },
  {
    alpha2: 'IE',
    alpha3: 'IRL',
    name: 'Ireland',
    numeric: '372',
  },
  {
    alpha2: 'IM',
    alpha3: 'IMN',
    name: 'Isle of Man',
    numeric: '833',
  },
  {
    alpha2: 'IL',
    alpha3: 'ISR',
    name: 'Israel',
    numeric: '376',
    officialName: 'State of Israel',
  },
  {
    alpha2: 'IT',
    alpha3: 'ITA',
    name: 'Italy',
    numeric: '380',
    officialName: 'Italian Republic',
  },
  {
    alpha2: 'JM',
    alpha3: 'JAM',
    name: 'Jamaica',
    numeric: '388',
  },
  {
    alpha2: 'JP',
    alpha3: 'JPN',
    name: 'Japan',
    numeric: '392',
  },
  {
    alpha2: 'JE',
    alpha3: 'JEY',
    name: 'Jersey',
    numeric: '832',
  },
  {
    alpha2: 'JO',
    alpha3: 'JOR',
    name: 'Jordan',
    numeric: '400',
    officialName: 'Hashemite Kingdom of Jordan',
  },
  {
    alpha2: 'KZ',
    alpha3: 'KAZ',
    name: 'Kazakhstan',
    numeric: '398',
    officialName: 'Republic of Kazakhstan',
  },
  {
    alpha2: 'KE',
    alpha3: 'KEN',
    name: 'Kenya',
    numeric: '404',
    officialName: 'Republic of Kenya',
  },
  {
    alpha2: 'KI',
    alpha3: 'KIR',
    name: 'Kiribati',
    numeric: '296',
    officialName: 'Republic of Kiribati',
  },
  {
    alpha2: 'KP',
    alpha3: 'PRK',
    name: "Korea, Democratic People's Republic of",
    numeric: '408',
    officialName: "Democratic People's Republic of Korea",
  },
  {
    alpha2: 'KR',
    alpha3: 'KOR',
    name: 'Korea, Republic of',
    numeric: '410',
  },
  {
    alpha2: 'KW',
    alpha3: 'KWT',
    name: 'Kuwait',
    numeric: '414',
    officialName: 'State of Kuwait',
  },
  {
    alpha2: 'KG',
    alpha3: 'KGZ',
    name: 'Kyrgyzstan',
    numeric: '417',
    officialName: 'Kyrgyz Republic',
  },
  {
    alpha2: 'LA',
    alpha3: 'LAO',
    name: "Lao People's Democratic Republic",
    numeric: '418',
  },
  {
    alpha2: 'LV',
    alpha3: 'LVA',
    name: 'Latvia',
    numeric: '428',
    officialName: 'Republic of Latvia',
  },
  {
    alpha2: 'LB',
    alpha3: 'LBN',
    name: 'Lebanon',
    numeric: '422',
    officialName: 'Lebanese Republic',
  },
  {
    alpha2: 'LS',
    alpha3: 'LSO',
    name: 'Lesotho',
    numeric: '426',
    officialName: 'Kingdom of Lesotho',
  },
  {
    alpha2: 'LR',
    alpha3: 'LBR',
    name: 'Liberia',
    numeric: '430',
    officialName: 'Republic of Liberia',
  },
  {
    alpha2: 'LY',
    alpha3: 'LBY',
    name: 'Libya',
    numeric: '434',
    officialName: 'Libya',
  },
  {
    alpha2: 'LI',
    alpha3: 'LIE',
    name: 'Liechtenstein',
    numeric: '438',
    officialName: 'Principality of Liechtenstein',
  },
  {
    alpha2: 'LT',
    alpha3: 'LTU',
    name: 'Lithuania',
    numeric: '440',
    officialName: 'Republic of Lithuania',
  },
  {
    alpha2: 'LU',
    alpha3: 'LUX',
    name: 'Luxembourg',
    numeric: '442',
    officialName: 'Grand Duchy of Luxembourg',
  },
  {
    alpha2: 'MO',
    alpha3: 'MAC',
    name: 'Macao',
    numeric: '446',
    officialName: 'Macao Special Administrative Region of China',
  },
  {
    alpha2: 'MG',
    alpha3: 'MDG',
    name: 'Madagascar',
    numeric: '450',
    officialName: 'Republic of Madagascar',
  },
  {
    alpha2: 'MW',
    alpha3: 'MWI',
    name: 'Malawi',
    numeric: '454',
    officialName: 'Republic of Malawi',
  },
  {
    alpha2: 'MY',
    alpha3: 'MYS',
    name: 'Malaysia',
    numeric: '458',
  },
  {
    alpha2: 'MV',
    alpha3: 'MDV',
    name: 'Maldives',
    numeric: '462',
    officialName: 'Republic of Maldives',
  },
  {
    alpha2: 'ML',
    alpha3: 'MLI',
    name: 'Mali',
    numeric: '466',
    officialName: 'Republic of Mali',
  },
  {
    alpha2: 'MT',
    alpha3: 'MLT',
    name: 'Malta',
    numeric: '470',
    officialName: 'Republic of Malta',
  },
  {
    alpha2: 'MH',
    alpha3: 'MHL',
    name: 'Marshall Islands',
    numeric: '584',
    officialName: 'Republic of the Marshall Islands',
  },
  {
    alpha2: 'MQ',
    alpha3: 'MTQ',
    name: 'Martinique',
    numeric: '474',
  },
  {
    alpha2: 'MR',
    alpha3: 'MRT',
    name: 'Mauritania',
    numeric: '478',
    officialName: 'Islamic Republic of Mauritania',
  },
  {
    alpha2: 'MU',
    alpha3: 'MUS',
    name: 'Mauritius',
    numeric: '480',
    officialName: 'Republic of Mauritius',
  },
  {
    alpha2: 'YT',
    alpha3: 'MYT',
    name: 'Mayotte',
    numeric: '175',
  },
  {
    alpha2: 'MX',
    alpha3: 'MEX',
    name: 'Mexico',
    numeric: '484',
    officialName: 'United Mexican States',
  },
  {
    alpha2: 'FM',
    alpha3: 'FSM',
    name: 'Micronesia, Federated States of',
    numeric: '583',
    officialName: 'Federated States of Micronesia',
  },
  {
    alpha2: 'MD',
    alpha3: 'MDA',
    common_name: 'Moldova',
    name: 'Moldova, Republic of',
    numeric: '498',
    officialName: 'Republic of Moldova',
  },
  {
    alpha2: 'MC',
    alpha3: 'MCO',
    name: 'Monaco',
    numeric: '492',
    officialName: 'Principality of Monaco',
  },
  {
    alpha2: 'MN',
    alpha3: 'MNG',
    name: 'Mongolia',
    numeric: '496',
  },
  {
    alpha2: 'ME',
    alpha3: 'MNE',
    name: 'Montenegro',
    numeric: '499',
    officialName: 'Montenegro',
  },
  {
    alpha2: 'MS',
    alpha3: 'MSR',
    name: 'Montserrat',
    numeric: '500',
  },
  {
    alpha2: 'MA',
    alpha3: 'MAR',
    name: 'Morocco',
    numeric: '504',
    officialName: 'Kingdom of Morocco',
  },
  {
    alpha2: 'MZ',
    alpha3: 'MOZ',
    name: 'Mozambique',
    numeric: '508',
    officialName: 'Republic of Mozambique',
  },
  {
    alpha2: 'MM',
    alpha3: 'MMR',
    name: 'Myanmar',
    numeric: '104',
    officialName: 'Republic of Myanmar',
  },
  {
    alpha2: 'NA',
    alpha3: 'NAM',
    name: 'Namibia',
    numeric: '516',
    officialName: 'Republic of Namibia',
  },
  {
    alpha2: 'NR',
    alpha3: 'NRU',
    name: 'Nauru',
    numeric: '520',
    officialName: 'Republic of Nauru',
  },
  {
    alpha2: 'NP',
    alpha3: 'NPL',
    name: 'Nepal',
    numeric: '524',
    officialName: 'Federal Democratic Republic of Nepal',
  },
  {
    alpha2: 'NL',
    alpha3: 'NLD',
    name: 'Netherlands',
    numeric: '528',
    officialName: 'Kingdom of the Netherlands',
  },
  {
    alpha2: 'NC',
    alpha3: 'NCL',
    name: 'New Caledonia',
    numeric: '540',
  },
  {
    alpha2: 'NZ',
    alpha3: 'NZL',
    name: 'New Zealand',
    numeric: '554',
  },
  {
    alpha2: 'NI',
    alpha3: 'NIC',
    name: 'Nicaragua',
    numeric: '558',
    officialName: 'Republic of Nicaragua',
  },
  {
    alpha2: 'NE',
    alpha3: 'NER',
    name: 'Niger',
    numeric: '562',
    officialName: 'Republic of the Niger',
  },
  {
    alpha2: 'NG',
    alpha3: 'NGA',
    name: 'Nigeria',
    numeric: '566',
    officialName: 'Federal Republic of Nigeria',
  },
  {
    alpha2: 'NU',
    alpha3: 'NIU',
    name: 'Niue',
    numeric: '570',
    officialName: 'Niue',
  },
  {
    alpha2: 'NF',
    alpha3: 'NFK',
    name: 'Norfolk Island',
    numeric: '574',
  },
  {
    alpha2: 'MK',
    alpha3: 'MKD',
    name: 'North Macedonia',
    numeric: '807',
    officialName: 'Republic of North Macedonia',
  },
  {
    alpha2: 'MP',
    alpha3: 'MNP',
    name: 'Northern Mariana Islands',
    numeric: '580',
    officialName: 'Commonwealth of the Northern Mariana Islands',
  },
  {
    alpha2: 'NO',
    alpha3: 'NOR',
    name: 'Norway',
    numeric: '578',
    officialName: 'Kingdom of Norway',
  },
  {
    alpha2: 'OM',
    alpha3: 'OMN',
    name: 'Oman',
    numeric: '512',
    officialName: 'Sultanate of Oman',
  },
  {
    alpha2: 'PK',
    alpha3: 'PAK',
    name: 'Pakistan',
    numeric: '586',
    officialName: 'Islamic Republic of Pakistan',
  },
  {
    alpha2: 'PW',
    alpha3: 'PLW',
    name: 'Palau',
    numeric: '585',
    officialName: 'Republic of Palau',
  },
  {
    alpha2: 'PS',
    alpha3: 'PSE',
    name: 'Palestine, State of',
    numeric: '275',
    officialName: 'the State of Palestine',
  },
  {
    alpha2: 'PA',
    alpha3: 'PAN',
    name: 'Panama',
    numeric: '591',
    officialName: 'Republic of Panama',
  },
  {
    alpha2: 'PG',
    alpha3: 'PNG',
    name: 'Papua New Guinea',
    numeric: '598',
    officialName: 'Independent State of Papua New Guinea',
  },
  {
    alpha2: 'PY',
    alpha3: 'PRY',
    name: 'Paraguay',
    numeric: '600',
    officialName: 'Republic of Paraguay',
  },
  {
    alpha2: 'PE',
    alpha3: 'PER',
    name: 'Peru',
    numeric: '604',
    officialName: 'Republic of Peru',
  },
  {
    alpha2: 'PH',
    alpha3: 'PHL',
    name: 'Philippines',
    numeric: '608',
    officialName: 'Republic of the Philippines',
  },
  {
    alpha2: 'PN',
    alpha3: 'PCN',
    name: 'Pitcairn',
    numeric: '612',
  },
  {
    alpha2: 'PL',
    alpha3: 'POL',
    name: 'Poland',
    numeric: '616',
    officialName: 'Republic of Poland',
  },
  {
    alpha2: 'PT',
    alpha3: 'PRT',
    name: 'Portugal',
    numeric: '620',
    officialName: 'Portuguese Republic',
  },
  {
    alpha2: 'PR',
    alpha3: 'PRI',
    name: 'Puerto Rico',
    numeric: '630',
  },
  {
    alpha2: 'QA',
    alpha3: 'QAT',
    name: 'Qatar',
    numeric: '634',
    officialName: 'State of Qatar',
  },
  {
    alpha2: 'RO',
    alpha3: 'ROU',
    name: 'Romania',
    numeric: '642',
  },
  {
    alpha2: 'RU',
    alpha3: 'RUS',
    name: 'Russian Federation',
    numeric: '643',
  },
  {
    alpha2: 'RW',
    alpha3: 'RWA',
    name: 'Rwanda',
    numeric: '646',
    officialName: 'Rwandese Republic',
  },
  {
    alpha2: 'RE',
    alpha3: 'REU',
    name: 'Réunion',
    numeric: '638',
  },
  {
    alpha2: 'BL',
    alpha3: 'BLM',
    name: 'Saint Barthélemy',
    numeric: '652',
  },
  {
    alpha2: 'SH',
    alpha3: 'SHN',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    numeric: '654',
  },
  {
    alpha2: 'KN',
    alpha3: 'KNA',
    name: 'Saint Kitts and Nevis',
    numeric: '659',
  },
  {
    alpha2: 'LC',
    alpha3: 'LCA',
    name: 'Saint Lucia',
    numeric: '662',
  },
  {
    alpha2: 'MF',
    alpha3: 'MAF',
    name: 'Saint Martin (French part)',
    numeric: '663',
  },
  {
    alpha2: 'PM',
    alpha3: 'SPM',
    name: 'Saint Pierre and Miquelon',
    numeric: '666',
  },
  {
    alpha2: 'VC',
    alpha3: 'VCT',
    name: 'Saint Vincent and the Grenadines',
    numeric: '670',
  },
  {
    alpha2: 'WS',
    alpha3: 'WSM',
    name: 'Samoa',
    numeric: '882',
    officialName: 'Independent State of Samoa',
  },
  {
    alpha2: 'SM',
    alpha3: 'SMR',
    name: 'San Marino',
    numeric: '674',
    officialName: 'Republic of San Marino',
  },
  {
    alpha2: 'ST',
    alpha3: 'STP',
    name: 'Sao Tome and Principe',
    numeric: '678',
    officialName: 'Democratic Republic of Sao Tome and Principe',
  },
  {
    alpha2: 'SA',
    alpha3: 'SAU',
    name: 'Saudi Arabia',
    numeric: '682',
    officialName: 'Kingdom of Saudi Arabia',
  },
  {
    alpha2: 'SN',
    alpha3: 'SEN',
    name: 'Senegal',
    numeric: '686',
    officialName: 'Republic of Senegal',
  },
  {
    alpha2: 'RS',
    alpha3: 'SRB',
    name: 'Serbia',
    numeric: '688',
    officialName: 'Republic of Serbia',
  },
  {
    alpha2: 'SC',
    alpha3: 'SYC',
    name: 'Seychelles',
    numeric: '690',
    officialName: 'Republic of Seychelles',
  },
  {
    alpha2: 'SL',
    alpha3: 'SLE',
    name: 'Sierra Leone',
    numeric: '694',
    officialName: 'Republic of Sierra Leone',
  },
  {
    alpha2: 'SG',
    alpha3: 'SGP',
    name: 'Singapore',
    numeric: '702',
    officialName: 'Republic of Singapore',
  },
  {
    alpha2: 'SX',
    alpha3: 'SXM',
    name: 'Sint Maarten (Dutch part)',
    numeric: '534',
    officialName: 'Sint Maarten (Dutch part)',
  },
  {
    alpha2: 'SK',
    alpha3: 'SVK',
    name: 'Slovakia',
    numeric: '703',
    officialName: 'Slovak Republic',
  },
  {
    alpha2: 'SI',
    alpha3: 'SVN',
    name: 'Slovenia',
    numeric: '705',
    officialName: 'Republic of Slovenia',
  },
  {
    alpha2: 'SB',
    alpha3: 'SLB',
    name: 'Solomon Islands',
    numeric: '090',
  },
  {
    alpha2: 'SO',
    alpha3: 'SOM',
    name: 'Somalia',
    numeric: '706',
    officialName: 'Federal Republic of Somalia',
  },
  {
    alpha2: 'ZA',
    alpha3: 'ZAF',
    name: 'South Africa',
    numeric: '710',
    officialName: 'Republic of South Africa',
  },
  {
    alpha2: 'GS',
    alpha3: 'SGS',
    name: 'South Georgia and the South Sandwich Islands',
    numeric: '239',
  },
  {
    alpha2: 'SS',
    alpha3: 'SSD',
    name: 'South Sudan',
    numeric: '728',
    officialName: 'Republic of South Sudan',
  },
  {
    alpha2: 'ES',
    alpha3: 'ESP',
    name: 'Spain',
    numeric: '724',
    officialName: 'Kingdom of Spain',
  },
  {
    alpha2: 'LK',
    alpha3: 'LKA',
    name: 'Sri Lanka',
    numeric: '144',
    officialName: 'Democratic Socialist Republic of Sri Lanka',
  },
  {
    alpha2: 'SD',
    alpha3: 'SDN',
    name: 'Sudan',
    numeric: '729',
    officialName: 'Republic of the Sudan',
  },
  {
    alpha2: 'SR',
    alpha3: 'SUR',
    name: 'Suriname',
    numeric: '740',
    officialName: 'Republic of Suriname',
  },
  {
    alpha2: 'SJ',
    alpha3: 'SJM',
    name: 'Svalbard and Jan Mayen',
    numeric: '744',
  },
  {
    alpha2: 'SE',
    alpha3: 'SWE',
    name: 'Sweden',
    numeric: '752',
    officialName: 'Kingdom of Sweden',
  },
  {
    alpha2: 'CH',
    alpha3: 'CHE',
    name: 'Switzerland',
    numeric: '756',
    officialName: 'Swiss Confederation',
  },
  {
    alpha2: 'SY',
    alpha3: 'SYR',
    name: 'Syrian Arab Republic',
    numeric: '760',
  },
  {
    alpha2: 'TW',
    alpha3: 'TWN',
    common_name: 'Taiwan',
    name: 'Taiwan, Province of China',
    numeric: '158',
    officialName: 'Taiwan, Province of China',
  },
  {
    alpha2: 'TJ',
    alpha3: 'TJK',
    name: 'Tajikistan',
    numeric: '762',
    officialName: 'Republic of Tajikistan',
  },
  {
    alpha2: 'TZ',
    alpha3: 'TZA',
    common_name: 'Tanzania',
    name: 'Tanzania, United Republic of',
    numeric: '834',
    officialName: 'United Republic of Tanzania',
  },
  {
    alpha2: 'TH',
    alpha3: 'THA',
    name: 'Thailand',
    numeric: '764',
    officialName: 'Kingdom of Thailand',
  },
  {
    alpha2: 'TL',
    alpha3: 'TLS',
    name: 'Timor-Leste',
    numeric: '626',
    officialName: 'Democratic Republic of Timor-Leste',
  },
  {
    alpha2: 'TG',
    alpha3: 'TGO',
    name: 'Togo',
    numeric: '768',
    officialName: 'Togolese Republic',
  },
  {
    alpha2: 'TK',
    alpha3: 'TKL',
    name: 'Tokelau',
    numeric: '772',
  },
  {
    alpha2: 'TO',
    alpha3: 'TON',
    name: 'Tonga',
    numeric: '776',
    officialName: 'Kingdom of Tonga',
  },
  {
    alpha2: 'TT',
    alpha3: 'TTO',
    name: 'Trinidad and Tobago',
    numeric: '780',
    officialName: 'Republic of Trinidad and Tobago',
  },
  {
    alpha2: 'TN',
    alpha3: 'TUN',
    name: 'Tunisia',
    numeric: '788',
    officialName: 'Republic of Tunisia',
  },
  {
    alpha2: 'TR',
    alpha3: 'TUR',
    name: 'Turkey',
    numeric: '792',
    officialName: 'Republic of Turkey',
  },
  {
    alpha2: 'TM',
    alpha3: 'TKM',
    name: 'Turkmenistan',
    numeric: '795',
  },
  {
    alpha2: 'TC',
    alpha3: 'TCA',
    name: 'Turks and Caicos Islands',
    numeric: '796',
  },
  {
    alpha2: 'TV',
    alpha3: 'TUV',
    name: 'Tuvalu',
    numeric: '798',
  },
  {
    alpha2: 'UG',
    alpha3: 'UGA',
    name: 'Uganda',
    numeric: '800',
    officialName: 'Republic of Uganda',
  },
  {
    alpha2: 'UA',
    alpha3: 'UKR',
    name: 'Ukraine',
    numeric: '804',
  },
  {
    alpha2: 'AE',
    alpha3: 'ARE',
    name: 'United Arab Emirates',
    numeric: '784',
  },
  {
    alpha2: 'GB',
    alpha3: 'GBR',
    name: 'United Kingdom',
    numeric: '826',
    officialName: 'United Kingdom of Great Britain and Northern Ireland',
  },
  {
    alpha2: 'US',
    alpha3: 'USA',
    name: 'United States',
    numeric: '840',
    officialName: 'United States of America',
  },
  {
    alpha2: 'UM',
    alpha3: 'UMI',
    name: 'United States Minor Outlying Islands',
    numeric: '581',
  },
  {
    alpha2: 'UY',
    alpha3: 'URY',
    name: 'Uruguay',
    numeric: '858',
    officialName: 'Eastern Republic of Uruguay',
  },
  {
    alpha2: 'UZ',
    alpha3: 'UZB',
    name: 'Uzbekistan',
    numeric: '860',
    officialName: 'Republic of Uzbekistan',
  },
  {
    alpha2: 'VU',
    alpha3: 'VUT',
    name: 'Vanuatu',
    numeric: '548',
    officialName: 'Republic of Vanuatu',
  },
  {
    alpha2: 'VE',
    alpha3: 'VEN',
    common_name: 'Venezuela',
    name: 'Venezuela, Bolivarian Republic of',
    numeric: '862',
    officialName: 'Bolivarian Republic of Venezuela',
  },
  {
    alpha2: 'VN',
    alpha3: 'VNM',
    common_name: 'Vietnam',
    name: 'Viet Nam',
    numeric: '704',
    officialName: 'Socialist Republic of Viet Nam',
  },
  {
    alpha2: 'VG',
    alpha3: 'VGB',
    name: 'Virgin Islands, British',
    numeric: '092',
    officialName: 'British Virgin Islands',
  },
  {
    alpha2: 'VI',
    alpha3: 'VIR',
    name: 'Virgin Islands, U.S.',
    numeric: '850',
    officialName: 'Virgin Islands of the United States',
  },
  {
    alpha2: 'WF',
    alpha3: 'WLF',
    name: 'Wallis and Futuna',
    numeric: '876',
  },
  {
    alpha2: 'EH',
    alpha3: 'ESH',
    name: 'Western Sahara',
    numeric: '732',
  },
  {
    alpha2: 'YE',
    alpha3: 'YEM',
    name: 'Yemen',
    numeric: '887',
    officialName: 'Republic of Yemen',
  },
  {
    alpha2: 'ZM',
    alpha3: 'ZMB',
    name: 'Zambia',
    numeric: '894',
    officialName: 'Republic of Zambia',
  },
  {
    alpha2: 'ZW',
    alpha3: 'ZWE',
    name: 'Zimbabwe',
    numeric: '716',
    officialName: 'Republic of Zimbabwe',
  },
  {
    alpha2: 'AX',
    alpha3: 'ALA',
    name: 'Åland Islands',
    numeric: '248',
  },
];

const EUCountries = {
  AT: 'Austria',
  BE: 'Belgium',
  BG: 'Bulgaria',
  HR: 'Croatia',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  EE: 'Estonia',
  FI: 'Finland',
  FR: 'France',
  DE: 'Germany',
  GR: 'Greece',
  HU: 'Hungary',
  IE: 'Ireland',
  IT: 'Italy',
  LV: 'Latvia',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MT: 'Malta',
  NL: 'Netherlands',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  SK: 'Slovakia',
  SI: 'Slovenia',
  ES: 'Spain',
  SE: 'Sweden',
};

const isEU = country => {
  return Object.prototype.hasOwnProperty.call(EUCountries, country);
};

function getCountryName(countryCode) {
  const country = countries.find(c => c.alpha2 === countryCode);
  return country ? country.name : '';
}

export { countries, EUCountries, isEU, getCountryName };
